import React from 'react';

import constants from '../constants';
import StakeFormatter from './StakeFormatter';

import "./StakeFormatter.css";

class DelegateWithSmartStake extends React.Component {
  render() {
    if (constants.ui.delegateToSmartStake === false) {
      return "";
    }

    return (
      <span className="delegateContainer">
        <div className="miniStat">
          <div className="miniStatTitle">
            <StakeFormatter name="Smart Stake" address={constants.app.smartStakeAddress} 
                label="Delegate to Smart Stake" isSS="true" />
          </div>
        </div>
      </span>
    );
  }
}

export default DelegateWithSmartStake;
